/*
 * Copyright (c) 2017 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.common.timer

/**
 * Created by luc on 22.04.17.
 */
abstract class AbstractCPTimer : CPTimer {
    protected var listeners: MutableList<CPTimerListener> = ArrayList<CPTimerListener>()
    override fun addTimerListener(listener: CPTimerListener) {
        listeners.add(listener)
    }

    override fun removeTimerListener(listener: CPTimerListener) {
        listeners.remove(listener)
    }
}